import { render, staticRenderFns } from "./ExtraProtectionInfo.vue?vue&type=template&id=7c00037d&scoped=true&"
import script from "./ExtraProtectionInfo.vue?vue&type=script&lang=js&"
export * from "./ExtraProtectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00037d",
  null
  
)

export default component.exports